
import { setTimeout } from 'timers';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Collapsible extends Vue {
    @Prop({ default: true })
    initCollapsed: boolean;
    @Prop() title: string;
    private collapsed: boolean = true;

    created() {
        this.collapsed = this.initCollapsed;
    }

    public toggleCollapse() {
        this.collapsed = !this.collapsed;
        // Wait for collapsible to complete, then emit
        setTimeout(() => this.$emit('toggleCollapse', this.collapsed), 450);
    }
}
